import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import style from "../../../scss/Dashboard.module.scss";
import { etiquetaTipoCandidato } from "../../../constants/tiposCandidato";
import { MOTIVOS_PROBLEMA, rutaEscrutinio } from "../../../utils/problemasMesa";

export const EtiquetaMotivo = ({ clave }) => {
  const motivo = MOTIVOS_PROBLEMA[clave];
  return (
    <span className={`badge ${motivo.clase} ${style.motivo}`}>
      <Icon icon={motivo.icono} aria-hidden="true" />
      {motivo.etiqueta}
    </span>
  );
};

// Tarjeta de una mesa escrutada (con sus motivos si tiene problemas).
// Toda la tarjeta lleva al Registro de votación con esa mesa cargada.
const MesaTarjetaComponent = ({ mesa }) => {
  const cerrada = mesa.estado === "cerrado";
  const tieneProblemas = mesa.motivos.length > 0;
  const claseEstado = tieneProblemas ? style.mesaProblema : cerrada ? style.mesaCerrada : "";

  return (
    <Link
      to={rutaEscrutinio(mesa)}
      className={`${style.mesa} ${claseEstado}`}
      title={`Abrir el escrutinio de ${mesa.lugar}, mesa ${mesa.mesa}`}
    >
      <div className={style.mesaCabecera}>
        <p className={style.mesaTitulo}>
          {mesa.lugar} · Mesa {mesa.mesa}
        </p>
        <span className={style.mesaMeta}>
          {etiquetaTipoCandidato(mesa.corporacion)} ·{" "}
          <span className={cerrada ? style.estadoCerrada : style.estadoAbierta}>
            <Icon icon={cerrada ? "mdi:lock-outline" : "mdi:lock-open-variant-outline"} aria-hidden="true" />
            {cerrada ? "Cerrada" : "Abierta"}
          </span>
        </span>
      </div>

      {tieneProblemas && (
        <div className={style.motivos}>
          {mesa.motivos.map((motivo) => (
            <EtiquetaMotivo key={motivo.clave} clave={motivo.clave} />
          ))}
        </div>
      )}

      {(tieneProblemas || mesa.observacion) && (
        <dl className={style.mesaDatos}>
          {mesa.motivos
            .filter((motivo) => motivo.detalle)
            .map((motivo) => (
              <div key={motivo.clave}>
                <dt>Novedad</dt>
                <dd>{motivo.detalle}</dd>
              </div>
            ))}
          {mesa.observacion && (
            <div>
              <dt>Observación</dt>
              <dd>{mesa.observacion}</dd>
            </div>
          )}
          {mesa.reconteoSolicitadoPor && (
            <div>
              <dt>Solicitado por</dt>
              <dd>
                {mesa.reconteoSolicitadoPor}
                {mesa.reconteoEnRepresentacionDe && ` (en representación de ${mesa.reconteoEnRepresentacionDe})`}
              </dd>
            </div>
          )}
        </dl>
      )}

      <span className={style.mesaAccion}>
        Ver escrutinio <Icon icon="mdi:arrow-right" aria-hidden="true" />
      </span>
    </Link>
  );
};

export default MesaTarjetaComponent;
